import { LogErrors } from './../../LogErrors'
import { UpdateSessionInfo } from './../Sessions'

import { GetCourses as DLGetCourses, GetChoosenCourse as DLGetChoosenCourse, ValidateLicense as DLValidateLicense, UseInstructorLicense as DLUseInstructorLicense, ValidateNumberOfExamsTaken as DLValidateNumberOfExamsTaken, GetCourseProgress as BLGetCourseProgress, GetCourseProgressInstructor as DLGetCourseProgressInstructor, GetCenterFreeLicensesStatus as DLGetCenterFreeLicensesStatus } from './../../DL/Student/Courses'


//Poner multiidioma a los mensajes de error


const rolesData = {
  ZTUDIANTE: 1,
  INSTRUCTOR: 2,
  LEADER: 3
}


const GetCourses = async (session, centerSelected, roleSelected) => {
    try {
      //Validar que exista la info del usuario en el session storage
      if (!sessionStorage.getItem('userData')) {
        return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
      }
  
      //Obtener la info del usuario desde el session storage
      const userData = JSON.parse(sessionStorage.getItem('userData'))
      
      //Comprobar varias propiedades para ver si está correcta la info del usuario
      if (userData.token === undefined || userData.token === '') {
          return { success: false, message: '' } //Mensaje indicando que su sesión ha expirado.
      }

      //const response = await DLGetCourses(session.token, centerSelected, roleSelected)
      const response = await DLGetCourses(userData.token, centerSelected, roleSelected)
  
      if (response.success) {
        userData.user.courses = response.data
  
        const newData = await UpdateSessionInfo(userData)
        
        return { success: true, data: newData.data }
      } else {
        return { success: false, message: response.message }
      }
    } catch (error) {
      await LogErrors('GetCourses - BL Courses', error)
      return { success: false, message: '' }
    }
}

const GetChoosenCourse = async (role) => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }

    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))

    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const idCourse = userData?.navigation?.course?.id
    if (!idCourse) {
      return { success: false, message: '' }
    }

    const idCenter = userData?.navigation?.center?.id
    
    if (!idCenter) {
      return { success: false, message: '' }
    }

    let response = null

    if (role === rolesData.ZTUDIANTE) {
      response = await DLGetChoosenCourse(token, idCourse, idCenter)

    } else if (role === rolesData.INSTRUCTOR) {
      response = await DLGetChoosenCourse(token, idCourse, idCenter, role)

    } else if (role === rolesData.LEADER) {
      // El Líder consulta el curso de un Instructor al que hace referencia; ese id se guardó
      // en la sesión al elegir el curso desde la vista de progreso.
      const idInstructor = userData?.navigation?.course?.idInstructor
      if (!idInstructor) {
        return { success: false, message: '' }
      }

      response = await DLGetChoosenCourse(token, idCourse, idCenter, role, idInstructor)
    }

    if (!response) {
      return { success: false, message: '' }
    }

    if (response.success) {
      // Guardar la info del curso en la propiedad en donde se irán poniendo todos los consultados
      userData.courses = response.data
      
      // Actualizar información del usuario en la sesión
      const responseSession = await UpdateSessionInfo(userData)
      
      if (responseSession.success) {
        return { success: true, data: responseSession.data }
      } else {
        return { success: false, message: responseSession.message }
      }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('GetChoosenCourse - BL Courses', error)
    return { success: false, message: '' }
  }
}

/**
 * Consulta si el Ztudiante ya utilizó una licencia para el curso indicado. Recibe idCourse
 * como parámetro (no desde la sesión) porque se llama ANTES de elegir el curso a mostrar.
 */
const ValidateLicense = async (idCourse) => {
  try {
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' }
    }

    const userData = JSON.parse(sessionStorage.getItem('userData'))

    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const idCenter = userData?.navigation?.center?.id
    if (!idCenter) {
      return { success: false, message: '' }
    }

    if (!idCourse) {
      return { success: false, message: '' }
    }

    const response = await DLValidateLicense(token, idCenter, idCourse)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('ValidateLicense - BL Courses', error)
    return { success: false, message: '' }
  }
}

/**
 * Registra el uso de una licencia para el curso indicado.
 */
const UseLicense = async (idCourse) => {
  try {
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' }
    }

    const userData = JSON.parse(sessionStorage.getItem('userData'))

    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const idCenter = userData?.navigation?.center?.id
    if (!idCenter) {
      return { success: false, message: '' }
    }

    if (!idCourse) {
      return { success: false, message: '' }
    }

    const response = await DLUseInstructorLicense(token, idCenter, idCourse)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('UseLicense - BL Courses', error)
    return { success: false, message: '' }
  }
}

/**
 * Consulta si el centro está en modalidad de licencias gratuitas, para decidir si al
 * entrar a un curso debe correr el flujo de ValidateLicense/UseLicense o no.
 */
const GetCenterFreeLicensesStatus = async () => {
  try {
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' }
    }

    const userData = JSON.parse(sessionStorage.getItem('userData'))

    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const idCenter = userData?.navigation?.center?.id
    if (!idCenter) {
      return { success: false, message: '' }
    }

    const response = await DLGetCenterFreeLicensesStatus(token, idCenter)

    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('GetCenterFreeLicensesStatus - BL Courses', error)
    return { success: false, message: '' }
  }
}

const GetDataFromTheChosenCourse = async (session, idCourse) => {
  try {
    if (session.user.courses === undefined || session.user.courses === null) {
      return { success: false, data: '' }
    }

    //Comprobar varias propiedades para ver si está correcta la info del usuario
    if (session.user.courses.myCourses === undefined || session.user.courses.myCourses === null) {
      return { success: false, data: '' }
    }

    if (session.user.courses.myCourses.length === 0) {
      return { success: false, data: '' }
    }

    const course = session.user.courses.myCourses.find(myCourse => myCourse.id === idCourse)
    
    if (!course) {
      return { success: true, data: '' }
    }

    return { success: true, data: course }
  } catch (error) {
    await LogErrors('GetDataFromTheChosenCourse - BL Courses', error)
    return { success: false, message: '' }
  }
}

const ResetChoosenCourse = async (session) => {
  try {
    if (session.courses === undefined) {
      return { success: true, data: session }
    } else {
      session.courses = null

      // Actualizar información del usuario en la sesión
      const response = await UpdateSessionInfo(session)
      
      if (response.success) {
        return { success: true, data: response.data }
      } else {
        return { success: false, message: 'Hubo un error al intentar cargar la información del curso. Inténtalo nuevamente o inténtalo más tarde.' }
      }
    }
  } catch (error) {
    await LogErrors('ResetChoosenCourse - BL Courses', error)
    return { success: false, message: '' }
  }
}

const ValidateNumberOfExamsTaken = async (instrument) => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }

    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))
    
    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const idCenter = userData?.navigation?.center?.id
    if (!idCenter) {
      return { success: false, message: '' }
    }

    const idCourse = userData?.navigation?.course?.id
    if (!idCourse) {
      return { success: false, message: '' }
    }
    
    const idItem = instrument?.id
    if (!idItem) {
      return { success: false, message: '' }
    }

    if (isNaN(idItem)) {
      return { success: false, message: '' }
    }
    
    const response = await DLValidateNumberOfExamsTaken(token, idCenter, idCourse, idItem)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('GetChoosenCourse - Courses DL', error)
    return { success: false, message: '' }
  }
}

const GetCourseProgress = async () => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }

    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))
    
    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const idCenter = userData?.navigation?.center?.id
    if (!idCenter) {
      return { success: false, message: '' }
    }

    const idCourse = userData?.navigation?.course?.id
    if (!idCourse) {
      return { success: false, message: '' }
    }
    
    const response = await BLGetCourseProgress(idCenter, idCourse, token)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('GetCourseProgress - Courses BL', error)
    return { success: false, message: 'No hay sido posible obtener el avance del curso' }
  }
}

const GetCourseProgressInstructor = async (idUser) => {
  try {
    //Validar que exista la info del usuario en el session storage
    if (!sessionStorage.getItem('userData')) {
      return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
    }

    //Obtener la info del usuario desde el session storage
    const userData = JSON.parse(sessionStorage.getItem('userData'))
    
    const token = userData?.token
    if (!token) {
      return { success: false, message: '' }
    }

    const idCenter = userData?.navigation?.center?.id
    if (!idCenter) {
      return { success: false, message: '' }
    }

    const idCourse = userData?.navigation?.course?.id
    if (!idCourse) {
      return { success: false, message: '' }
    }
    
    if (!idUser || isNaN(idUser)) {
      return { success: false, message: '' }
    }
    
    const response = await DLGetCourseProgressInstructor(idCenter, idCourse, idUser, token)
    
    if (response.success) {
      return { success: true, data: response.data }
    } else {
      return { success: false, message: response.message }
    }
  } catch (error) {
    await LogErrors('GetCourseProgressInstructor - Courses BL', error)
    return { success: false, message: 'No hay sido posible obtener el avance del curso' }
  }
}

export { GetCourses, GetChoosenCourse, GetDataFromTheChosenCourse, ResetChoosenCourse, ValidateLicense, UseLicense, ValidateNumberOfExamsTaken, GetCourseProgress, GetCourseProgressInstructor, GetCenterFreeLicensesStatus };